import { useEffect, useState } from "react";
import className from "classnames";
import { useNavigate, useParams } from "react-router-dom"
import { setNavbarTitle } from "features/navbar/navbarSlice";
import { useDispatch } from "react-redux";
import { Globals } from "utils/styleconfig";
import { RiArrowRightSLine, RiCloseFill, RiEditBoxLine } from "react-icons/ri";
import Button from "components/UI/Button/Button";

import List from "components/List/List";
import utilityStyles from "styles/modules/Utility.module.scss";
import { useGetDIDQuery } from "features/did/didApiSlice";
import EditDID from "../EditDID/EditDID";

const ViewDID = ({ label }) => {
    const params = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [isEditVisible, setEditVisible] = useState(false);

    useEffect(() => {
        dispatch(setNavbarTitle("View DID"));
    }, [dispatch]);

    const { data: did } = useGetDIDQuery(params?.id);

    const toggleEditVisibility = () => {
        setEditVisible(!isEditVisible); // Toggle visibility on button click
    };

    const extensionData = [
        { label: "Number", value: did?.number },
        { label: "Connect Cost", value: did?.connectcost },
        { label: "Included Seconds", value: did?.includedseconds },
        { label: "Cost", value: did?.cost },
        { label: "Max Channels", value: did?.maxchannels },
        { label: "Init Inc", value: did?.init_inc },
        { label: "Inc", value: did?.inc },
        { label: "Leg Timeout", value: did?.leg_timeout },
        { label: "Ringback", value: did?.ringback },
        { label: "Always VM Flag", value: did?.always_vm_flag ? 'Yes' : 'No' },
        { label: "User Busy", value: did?.user_busy_vm_flag ? 'Yes' : 'No' },
        { label: "User Not Registered", value: did?.user_not_registered ? 'Yes' : 'No' },
        { label: "No Answer", value: did?.no_answer_vm_flag ? 'Yes' : 'No' },
        { label: "Call Type", value: did?.call_type_vm_flag ? 'Yes' : 'No' },
        { label: "Simultaneous Extension", value: did?.allow_call_recording ? 'Yes' : 'No' },
        { label: "Enabled", value: did?.enabled ? 'Yes' : 'No' },
    ];

    return (
        <>
            <div className={`${utilityStyles.grid} ${utilityStyles.grid_col2} ${utilityStyles.gap10}`}>
                <div className={`${utilityStyles.flexColumn} ${utilityStyles.justifyStart} ${utilityStyles.gap10} ${utilityStyles.colorWhite} ${utilityStyles.dataList} `} >
                    <List customStyle={`${utilityStyles.grid} ${utilityStyles.gap10}`} data={extensionData} />

                    <div>
                        {/* Button to toggle visibility */}
                        <Button onClick={toggleEditVisibility} className={`${utilityStyles.btn}`}>
                            {isEditVisible ? (
                                <RiCloseFill color={Globals.colorRed} size={30} />
                            ) : (
                                <>
                                    <h3>Edit DID </h3>
                                    <RiEditBoxLine color={Globals.colorDarkBlue} size={20} />
                                </>
                            )}
                        </Button>
                    </div>
                </div>
                {/* <div>
          <button
            onClick={onViewDevicesBtnHandler}
            className={utilityStyles.btn}
          >
            <h3>View extension devices</h3>
            <RiArrowRightSLine color={Globals.colorDarkBlue} size={16} />
          </button>
        </div> */}
            </div>

            {/* Edit DID Component Start*/}
            {isEditVisible && (
                <EditDID label={label} />)
            }

        </>
    )
}

export default ViewDID